
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_934PSiEAHnQbRJzstd9a2UCx2hOVyGUXlYx64MiOhZ0HIMeta } from "/codebuild/output/src3996917137/src/ark/pages/[...slug].vue?macro=true";
import { default as guiaszsl8fuPIjws6uQAacJMxl3Yg1zPgqXbjixIU1N7sStgMeta } from "/codebuild/output/src3996917137/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexkWEshklWeHR9XX0_nn_45_45_45dgGS6rtQ0A4feLz8vCcTtsMeta } from "/codebuild/output/src3996917137/src/ark/pages/blog/index.vue?macro=true";
import { default as temasrH9PBm_458LcLuKN_krctFl0Q9XTthC3R4unTyXjizwZ0Meta } from "/codebuild/output/src3996917137/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisao3unUD6r2XP0_454vj5WfjaCNuNVUnCd8ZpIuMpVTjzNsMeta } from "/codebuild/output/src3996917137/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaCDG7GofacCet1KacKEYHIlBK_45LWwxvIwpyJ_k2M1ewkMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesjPfpRZFpdBjCMEMJadU_GDkR157KUXKyQWM4nPYfiKYMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasqzGFyrHUs1HHjoINstZKQtn3buXBwpRYkn1jQ_45dOapsMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casa3o48TvxbXNCi_452mkgDUfMBfeeZvlYzRJuF5ZusVVAl4Meta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoi8myIpTtvfDCqwOQcGbE_45gmckjk58DYvfr9eObbpi0oMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadorajWLGTU5zkHyFd2l4fwDmsXLeUFYxSQpAXJBKo_lMb5MMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoj1oIy54lQcVC_45qk4snWCsLL2Nmoaxzrf5L8TkxPsJjkMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaXTLGDMtG7O5mw1uBKcduJ47FVdk_5sAhBSWsiokX1cwMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularINxmUZnOTcxpqn5TyBVsWjIhbaESV4kGLBYyVz4WFUYMeta } from "/codebuild/output/src3996917137/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetHozpS031TkZkMSw0g4gCkb5nlD_4_YzdXCy0plZhl8cMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemoveluSvWHb3NaRPtP0xgqJxbLk_bc_nJbDnVTVKpxfnJTg8Meta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaobGI9Wk8Bsbay3_45bFaJysnfOA04q_45oiADhCaV6Z_45jDncMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualfTlsNNHyrsMBw07l_N_452ib1AtpAVnPlgkYZJ33IH5ZQMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoJjBEs1FkvTnjIf8wuzQKIdtRemINlaIVkMmpybWG3XYMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularNAXmg1DNdBBdlWi_45p6Sizw5kv6Z79z16bDDjA7PlOT0Meta } from "/codebuild/output/src3996917137/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93KEyjLxMYg0syRtNKTO8Ztye7_45lFrVEyFs_457BmtkGBnUMeta } from "/codebuild/output/src3996917137/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93QuU3A5dbHaMTg3KjC4iua6xmfk3Qnw_m_Mo0O6hhcvoMeta } from "/codebuild/output/src3996917137/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumol5eBKswhe7BoonrgtcBaTR6upWecScGsrjnv9HRS4hwMeta } from "/codebuild/output/src3996917137/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeStqezQlbh6a_5fkbRT4xBRv_45pZ6Iu5KbV4iCujb7c7AMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxa2QvP_45_45woN1UNRDA0ubd5_45DpINz3L9xW6ZDr_45pIvDOC4Meta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoF9FD9aWYfqsaCWDbL8zmrUM5M_YmcZ3wrStl_KrKwF0Meta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoNaAD3qYL7Zjk_45o4JgMJE8oovzGXQU_45PRRsT8kR8OG1gMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeirav35qbl8DRoyCwhxGKj88UuZ4_XGh3UYh1RK3e_X9fa8Meta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoBcXRb2tRl7b0Ia5B_VS0GBCPlr_YRmabb85GX2JXY8YMeta } from "/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularNR6aaKVLseC2NJMEB2iyb0aGKU3rHO_Zqok7ROvGGA0Meta } from "/codebuild/output/src3996917137/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93Yc9hehPPT0On06CSkv9tRseahj06MAfDtRguWEkfCtIMeta } from "/codebuild/output/src3996917137/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosR4kq6eSMYRX1EVH0c5JKnfKJq1tr67w3JevrtGsCZZgMeta } from "/codebuild/output/src3996917137/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexdkiV04NESZ5otyks_U2NHm0iIar4H_45wQ_R2XmhEnCuMMeta } from "/codebuild/output/src3996917137/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93n18MRyWwRpd4WpGF1Im45anP3ccZ9I0lqUnjwPhpBVwMeta } from "/codebuild/output/src3996917137/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93lIUMbYn5rPxVvkmEMlScIVioTNgRLGheBOssre_45j8_QMeta } from "/codebuild/output/src3996917137/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: simularINxmUZnOTcxpqn5TyBVsWjIhbaESV4kGLBYyVz4WFUYMeta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: simularNAXmg1DNdBBdlWi_45p6Sizw5kv6Z79z16bDDjA7PlOT0Meta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: simularNR6aaKVLseC2NJMEB2iyb0aGKU3rHO_Zqok7ROvGGA0Meta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src3996917137/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93Yc9hehPPT0On06CSkv9tRseahj06MAfDtRguWEkfCtIMeta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosR4kq6eSMYRX1EVH0c5JKnfKJq1tr67w3JevrtGsCZZgMeta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93n18MRyWwRpd4WpGF1Im45anP3ccZ9I0lqUnjwPhpBVwMeta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93lIUMbYn5rPxVvkmEMlScIVioTNgRLGheBOssre_45j8_QMeta || {},
    component: () => import("/codebuild/output/src3996917137/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]